import { useLocalStorage } from "../../../hooks/useLocalStorage"
import styles from "./AnalyticsHeader.module.css"
import { AvatarsData } from "../../../data/avatar"
const AnalyticsHeader = () => {
  return (
      <div className={styles.analytics_container}>
          <div className={styles.content}>
              <div className={styles.avatar_container}>
              <img className={styles.avatar} src={useLocalStorage("ambientAvatar")} alt="" />

              </div>
              <div className={styles.profile}>
                  <span className={styles.name}>{ useLocalStorage("ambientHandle")}.abt</span>
              <span className={styles.address}>02x283...323</span>
                  <span>{useLocalStorage("ambientAvatar")}</span>
                 
              </div>
          </div>
          
      </div>
  )
}

export default AnalyticsHeader